export const offerMap = (offerId) => {
  switch (offerId) {
    case 'Grabaut_Zero_MB':
      return 'zero';
    case 'Grabaut_2NOW_MB':
      return '2now';
    case 'Grabaut_One_MB':
      return 'one';
    case 'Grabaut_Travel_O_MB':
      return 'gold';
    case 'Grabaut_Travel_P_MB':
      return 'platinum';
    case 'Grabaut_P_MB':
      return 'pwe';
    case 'Grabaut_AIR_MB':
      return 'air';
    case 'Grabaut_VIVA_MB':
      return 'viva';
    case 'Grabaut_VIVA_PLUS_MB':
      return 'vivaPlus';
    default:
      return null;
  }
};
